<div class="mt-6 w-full flex flex-col gap-5">
  <p-card>
    <ng-template #title>
      <h1>{{ 'controlPoints.history.title' | translate }}</h1>
    </ng-template>

    @if (service.checkins().length === 0) {
      <div class="text-color-secondary text-center py-16">
        {{ 'controlPoints.history.empty' | translate }}
      </div>
    } @else {
      <p-table
        [value]="service.checkins()"
        stripedRows
        showGridlines
        dataKey="id"
        [paginator]="true"
        [rows]="25"
        [scrollable]="true"
        [tableStyle]="{ 'min-width': '40rem' }"
      >
        <ng-template #header>
          <tr>
            <th>
              {{ 'controlPoints.history.columns.controlPoint' | translate }}
            </th>
            <th>{{ 'controlPoints.history.columns.trainer' | translate }}</th>
            <th>
              {{ 'controlPoints.history.columns.checkedInAt' | translate }}
            </th>
          </tr>
        </ng-template>
        <ng-template #body let-row>
          <tr>
            <td>{{ row.control_point_name ?? '—' }}</td>
            <td>{{ row.user_name ?? '—' }}</td>
            <td>
              {{
                row.checked_in_at | date: 'dd.MM.yyyy HH:mm' : 'Europe/Berlin'
              }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    }
  </p-card>
</div>
